export default ($) => {

	let zipForm = $('.zip-code__form');
  let zipInput = $('.zip-code__form-input');
	let zipFormItem = $('.zip-code__form-item');

	let zipFormHeader = $('.desktop-dealer-panel__form');
  let zipInputHeader = $('.desktop-dealer-panel__form-input');
	let zipFormItemHeader = $('.desktop-dealer-panel__form-item');

	function isValidPostalCode(postalCode, countryCode) {
		let postalCodeRegex;

    switch (countryCode) {
			case "US":
				postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
				break;
			case "CA":
				postalCodeRegex = /^([A-Z][0-9][A-Z])(\s*)([0-9][A-Z][0-9])/gmi;
				break;
    }
    return postalCodeRegex.test(postalCode);
	}

	zipForm.on('submit', () => {
		let zipValue = zipInput.val();
		let emptyInput = Array.from(zipInput).filter(input => input.value === '')
		let countryCode;

		if(/^[0-9]+$/.test(zipValue)) {
			countryCode = 'US';
		} else {
			countryCode = 'CA';
		}

		if(zipValue === '') {
			zipFormItem.addClass('error');
		} else {
			zipFormItem.removeClass('error');
		}

		if(emptyInput.length !== 0) {
			return false;
		}

		if(!isValidPostalCode(zipValue, countryCode)) {
			zipFormItem.addClass('error');

			return false;
		} else {
			zipFormItem.removeClass('error');
		}
	})

	zipFormHeader.on('submit', () => {
		let zipValue = zipInputHeader.val();
		let emptyInput = Array.from(zipInputHeader).filter(input => input.value === '')
		let countryCode;

		if(/^[0-9]+$/.test(zipValue)) {
			countryCode = 'US';
		} else {
			countryCode = 'CA';
		}

		if(zipValue === '') {
			zipFormItemHeader.addClass('error');
		} else {
			zipFormItemHeader.removeClass('error');
		}

		if(emptyInput.length !== 0) {
			return false;
		}

		if(!isValidPostalCode(zipValue, countryCode)) {
			zipFormItemHeader.addClass('error');

			return false;
		} else {
			zipFormItemHeader.removeClass('error');
		}
	})

	jQuery(document).on('gform_post_render', function(event, formId) {
		let error_field = jQuery(this).find('.js-postcode-validation.gfield_error')
		if ( error_field.length > 0 ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'GF_validation_error',
				'formId': formId,
				'field_value': error_field.find('input').val(),
				'error_message': error_field.find('.validation_message').text()
			});
		}
	});
}
